module.exports = __webpack_public_path__ + "static/media/yogiman.f3527f40.jpeg";